var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackToTop)?_c('button',{staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('img',{attrs:{"src":"https://download.hecoos.com/enlightv/2025-17/c97ffd76b131b2c2f724bec6da9b4ab3.png","alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }